// Per-plot geology derived from the static FieldDef + the plot's hidden truth (depth jitter, prospect).

export function strataAt(fdef, plot) {
  const m = plot.truth?.depthMult ?? 1;
  return (fdef.strata ?? []).map((s, idx) => ({
    ...s, idx,
    top: Math.round(s.top * m * 10) / 10,
    bottom: Math.round(s.bottom * m * 10) / 10,
    hard: s.hard ?? s.hardness ?? 3,
    stableDays: s.stableDays ?? 60,
  }));
}

export function stratumAt(strata, depth) {
  for (const s of strata) if (depth >= s.top && depth < s.bottom) return s;
  // below the last defined stratum: extend the last one
  return strata[strata.length - 1] ?? { idx: -1, rock: 'rock', hard: 5, pore: 8.6, frac: 14, top: 0, bottom: Infinity, stableDays: 999 };
}

// Reservoirs present under this plot (empty if outside every prospect), with plot-specific top depth.
export function reservoirsAt(fdef, plot) {
  const pi = plot.truth?.prospectIdx ?? -1;
  if (pi < 0) return [];
  const p = fdef.prospects?.[pi];
  if (!p) return [];
  const m = plot.truth.depthMult ?? 1;
  const dist = plot.truth.dist ?? 0;
  const out = (p.reservoirs ?? []).map((r) => ({
    ...r,
    top: Math.round((r.top + (r.dipFtPerPlot ?? 0) * dist) * m * 10) / 10,
    thick: r.thick ?? 15,
  })).sort((a, b) => a.top - b.top);
  // the company's first well (actions.firstWellLuck): the shallowest pay sits no deeper than payCap
  if (plot.truth.payCap != null && out.length && out[0].top > plot.truth.payCap) out[0] = { ...out[0], top: plot.truth.payCap };
  return out;
}
